import { Link } from 'react-router-dom';

const model = [
  'Оценка сотрудников',
  'Определение зон развития',
  'Индивидуальный план развития',
  'Обучение / наставничество / практика',
  'Применение в работе',
  'Повторная оценка',
];

export default function ClusterConnection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          ИПР — часть системы развития персонала
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Индивидуальный план развития работает внутри логической модели кластера «Развитие персонала»
        </p>

        <div className="flex flex-col items-center mb-12">
          {model.map((step, i) => (
            <div key={step} className="flex flex-col items-center">
              <div className="bg-white border border-teal-200 text-teal-700 px-6 py-3 rounded-lg text-sm md:text-base font-semibold text-center">
                {step}
              </div>
              {i < model.length - 1 && (
                <i className="ri-arrow-down-line text-teal-600 text-xl my-2"></i>
              )}
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/razvitie-personala"
            className="inline-flex items-center gap-2 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
          >
            Развитие персонала — хаб кластера
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}